<template>
	<div class="inputBox">
		<el-input :size="size" v-model="value" @input="input" style="width: 100%"> </el-input>
	</div>
</template>

<script>
export default {
	name: 'inputBox',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		let that = this;
		return {
			value: that.scope.row[that.tableData.bind],
		};
	},
	computed: {
		size() {
			return this.tableData.size || 'mini';
		},
	},
	watch: {
		'scope.row': {
			handler() {
				this.value = this.scope.row[this.tableData.bind];
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		input(val) {
			let { scope, tableData } = this;
			this.$set(this.scope.row, this.tableData.bind, this.value);
			tableData.change && tableData.change(val, scope, tableData);
		},
	},
};
</script>

<style lang="scss" scoped>
.inputBox {
	display: flex;
	.bianji-icon {
		margin-left: 10px;
		cursor: pointer;
	}
}
</style>
